import { render, staticRenderFns } from "./FenologiaManage.vue?vue&type=template&id=336f7763&scoped=true"
import script from "./FenologiaManage.vue?vue&type=script&lang=js"
export * from "./FenologiaManage.vue?vue&type=script&lang=js"
import style0 from "./FenologiaManage.vue?vue&type=style&index=0&id=336f7763&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336f7763",
  null
  
)

export default component.exports